import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const SecurityAlertList = () => {
  const columns = [
    { label: 'Alert Type', value: 'alert_type' },
    { label: 'Severity', value: 'severity' },
    { label: 'Timestamp', value: (item) => fmtDateTime(item.timestamp) },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/security/alert/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['securityAlert']} />;
};

export default SecurityAlertList;